<template>
    <v-btn
        color="secondary"
        class="btn-back mb-4"
        style="color: #333; width: 100%;"
        small
        height="40"
        @click="$emit('click')"
        :to="to"
        exact
        elevation="0"
    >
        <v-icon>mdi-chevron-left</v-icon>
        {{ label ? label : $t('msg.back') }}
    </v-btn>
</template>

<script>
export default {
    props: {
      label: {type: String, default: null},
      to: {type: Object, default: undefined},
    }
}
</script>

<style lang="scss">
.btn-back {
  .v-btn__content {
    font-size: 11px;
    font-weight: 400;
  }
}
</style>